import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import SSOAuthService from './SSOAuthService.ts';

interface AuthContextType {
  ssologin: (idpIdentifier) => void;
}

// Create the context with a default value
const SSOAuthContext = createContext<AuthContextType>({
  ssologin: (idpIdentifier) => {}
});

// Custom hook to use the auth context
export const useAuthSSO = () => useContext(SSOAuthContext);

interface AuthProviderProps {
  children: ReactNode;
}

export const SSOAuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const authSvc = new SSOAuthService();

  const ssologin = (idpIdentifier) => {
    authSvc.initiateLogin(idpIdentifier);
  };

  const value = useMemo(() => ({ ssologin }), []);

  return (
    <SSOAuthContext.Provider value={value}>
      {children}
    </SSOAuthContext.Provider>
  );
};